import type { CSSProperties, JSX, ReactNode } from "react"

import { Href } from "~/shared/ui/components"

import cssModule from "./index.module.scss"
import { cx } from "classix"
import { useLocation } from "react-router-dom-7"

export type SidebarLinkData = {
	title?: string
	url?: string
	target?: string
	onClick?: () => void
	customization?: {
		navItemColor?: string
		navItemHoverColor?: string
	}
	element?: JSX.Element
}

export type SidebarLinkProps = SidebarLinkData & {
	children?: ReactNode
}

interface SidebarLinkCSSProperties extends CSSProperties {
	"--nav-item-color"?: string;
	"--nav-item-hover-color"?: string;
}

export function SidebarLink({
								children,
								title,
								url,
								onClick,
								target,
								customization,
								...props
							}: SidebarLinkProps) {

	const loc = useLocation()

	const selectedLink = loc.pathname === url

	return (
		<li style={{
			"--nav-item-color": customization?.navItemColor,
			"--nav-item-hover-color": customization?.navItemHoverColor
		} satisfies SidebarLinkCSSProperties as SidebarLinkCSSProperties}
			className={cx(cssModule.navLinkContainer, selectedLink && cssModule.selectedNavLinkContainer)}
			{...props}>
			{url ? (
				<Href href={url} onClick={onClick} target={target} className={cssModule.navLink}>
					{title}
				</Href>
			) : (
				<div className={cssModule.navLink} onClick={onClick}>
					{children ?? title}
				</div>
			)}
		</li>
	)
}
